/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import { PrecoRegraQuery } from "./PrecoRegraQuery";
import useServico from "./useServico";
import { getFracionamentoDescarga } from "~services/GlobalServices";
import { useGetTabelaPrecoClienteById } from "~pages/PricesTable/hooks/usePricesTableQuery";
import { getPrecoCliente } from "~services/SincronizacaoServices";

const useTabelaPrecoCliente = ({
  filters,
  setLoading,
  clienteId,
  microrregiao,
  cluster,
  cidadeId,
  domicilioFiscal,
  codigoCliente,
  skip,
  take,
}) => {
  const { servicos } = useServico({ microrregiaoId: microrregiao });

  const [tabelaPrecoClientes, setTabelaPrecoClientes] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalRenderizado, setTotalRenderizado] = useState(0);

  const onLoading = () => {
    if (typeof setLoading == "function") setLoading(true);
  };

  const offLoading = () => {
    if (typeof setLoading == "function") setLoading(false);
  };

  const filterTabelaPrecoCliente = (precoCliente) => {
    return (
      (filters?.grupoProduto
        ? (precoCliente.grupoProdutoId ?? precoCliente.grupoMaterialId) === filters?.grupoProduto
        : true) &&
      (filters?.produto ? precoCliente.produtoId === filters?.produto : true) &&
      (filters?.filial ? precoCliente.filialId === filters?.filial : true) &&
      (filters?.unidadeMedida ? precoCliente.unidadeMedidaId === filters?.unidadeMedida : true) &&
      (filters?.tipoSolicitacao ? precoCliente.tipoCondicaoId === filters?.tipoSolicitacao : true) &&
      (filters?.cliente ? precoCliente.clienteId === filters?.cliente : true) &&
      (filters?.embalagem ? precoCliente.embalagemId === filters?.embalagemId : true)
    );
  };

  const isUndefinedOrNull = (value) => value === undefined || value === null;

  const parseNumericValue = (value) => {
    if (isUndefinedOrNull(value)) return null;

    if (typeof value === "string") {
      value = value.replace(/[^\d.-]/g, "");
      if (value === "") return null;
    }

    const num = Number(value);
    return isNaN(num) ? null : num;
  };

  const getQuery = (key, precosQuery, reverse = false) => {
    if (key === "faixa") {
      return precosQuery
        .offset(0)
        .limit(take + skip)
        .toArray()
        .then((items) => {
          return items.sort((a, b) => {
            const aFaixaRaw = a.faixa;
            const bFaixaRaw = b.faixa;

            let aValue = isUndefinedOrNull(aFaixaRaw) ? 0 : parseNumericValue(aFaixaRaw);
            let bValue = isUndefinedOrNull(bFaixaRaw) ? 0 : parseNumericValue(bFaixaRaw);

            aValue = aValue === null ? 0 : aValue;
            bValue = bValue === null ? 0 : bValue;

            return reverse ? bValue - aValue : aValue - bValue;
          });
        });
    }

    return reverse
      ? precosQuery
          .offset(0)
          .limit(take + skip)
          .reverse()
          .sortBy(key)
      : precosQuery
          .offset(0)
          .limit(take + skip)
          .sortBy(key);
  };

  const fetchTabelaPrecoClientes = async () => {
    onLoading();

    let precosQuery = PrecoRegraQuery({ clienteId, microrregiao, cluster, cidadeId, domicilioFiscal });
    precosQuery = precosQuery.filter(filterTabelaPrecoCliente);

    let tabelaPrecoClienteArray = [];

    if (filters?.ordem) {
      switch (filters.ordem) {
        case "ordem-alfabetica":
          tabelaPrecoClienteArray = await getQuery("produtoLabel", precosQuery);
          break;
        case "centro":
          tabelaPrecoClienteArray = await getQuery("filialLabel", precosQuery);
          break;
        case "grupo-produto":
          tabelaPrecoClienteArray = await getQuery("grupoProdutoId", precosQuery);
          break;
        case "ordem-crescente":
          tabelaPrecoClienteArray = await getQuery("faixa", precosQuery);
          break;
        case "ordem-decrescente":
          tabelaPrecoClienteArray = await getQuery("faixa", precosQuery, true);
          break;
        default:
          tabelaPrecoClienteArray = await precosQuery
            .offset(0)
            .limit(skip + take)
            .toArray();
          break;
      }
    }

    setTotal(await PrecoRegraQuery({ clienteId, microrregiao, cluster, cidadeId, domicilioFiscal }).count());
    setTotalRenderizado(tabelaPrecoClienteArray.length);
    setTabelaPrecoClientes(tabelaPrecoClienteArray);

    offLoading();
  };

  useEffect(() => {
    if (clienteId > 0 && (microrregiao || cluster)) {
      fetchTabelaPrecoClientes();
    }
  }, [clienteId, microrregiao, cluster, skip, take, filters]);

  function formatPrecoCliente(item) {
    const servicoMicro = (servicos || []).filter((opt) => opt.microrregiaoId == microrregiao);
    const precosServicos = getFracionamentoDescarga(servicoMicro, item);

    return {
      clienteLabel: item.clienteLabel,
      clienteNome: item.clienteNome,
      produtoLabel: item.produtoLabel,
      tipoCondicaoLabel: item.tipoCondicaoLabel,
      vigenciaLabel: item.vigenciaLabel,
      vigencia: item.vigencia,
      proximaVencimento: item.proximaVencimento,
      filialId: item.filialId,
      faixaF: item.faixa,
      produtoId: item.produtoId,
      unidadeMedidaId: item.unidadeMedidaId,
      familiaId: item.familiaId,
      nomeFilial: item.filialLabel,
      grupoMaterialId: item.grupoProdutoId,
      codigoProduto: item.codigoProduto,
      vigenciaTimestamp: item.vigenciaTimestamp,
      peso: item.peso,
      clienteId: item.clienteId,
      tipoCondicaoId: item.tipoCondicaoId,
      produtoFilialId: item.produtoFilialId,
      precoRegraCIF: item.precoRegraCIF,
      precoRegraFOB: item.precoRegraFOB,
      faixa: `${item.faixa}`,
      precoFinalCIF: item.precoFinalCIF,
      precoFinalFOB: item.precoFinalFOB,
      id: item.precoClienteId,
      prazoCIF: item.prazoCIF,
      prazoFOB: item.prazoFOB,
      prazoPagamentoCIFId: item.prazoPagamentoCIFId,
      prazoPagamentoFOBId: item.prazoPagamentoFOBId,
      ativo: true,
      isChecked: false,
      emAprovacao: item.emAprovacao && item?.clienteEmAprovacao?.includes(codigoCliente),
      precosServicos: precosServicos,
      sequencia: item.sequencia,
      color: {
        cif: !!item.precoEspecialCIF,
        fob: !!item.precoEspecialFOB,
      },
    };
  }

  function formatPrecoRegra(item, faixas, chaveUnica) {
    const servicoMicro = (servicos || []).filter((opt) => opt.microrregiaoId == microrregiao);
    const precosServicos = getFracionamentoDescarga(servicoMicro, item);

    const faixa = faixas[chaveUnica] !== undefined ? faixas[chaveUnica] : 0;

    return {
      codigoIdentificacao: item.codigoIdentificacao,
      microrregiaoId: item.microrregiaoId,
      estadoId: item.estadoId,
      cidadeId: item.cidadeId,
      nomeCidade: item.cidadeNome,
      clusterId: item.clusterId,
      nomeCluster: item.clusterNome,
      produtoFilialId: item.produtoFilialId,
      valorPrecoFOB: item.precoFinalFOB,
      valorPrecoCIF: item.precoFinalCIF,
      produtoId: item.produtoId,
      filialId: item.filialId,
      faixaF: faixa,
      faixa: `${faixa}`,
      familiaId: item.familiaId,
      codigoProduto: item.codigoProduto,
      descricaoProduto: item.produtoLabel,
      codigoFilial: item.codigoFilial,
      nomeFilial: item.filialLabel,
      codigoMicrorregiao: item.microrregiaoCodigo,
      nomeMicrorregiao: item.microrregiaoNome,
      grupoMaterialId: item.grupoProdutoId,
      grupoMaterialNome: item.grupoProdutoNome,
      peso: item.peso,
      unidadeMedidaId: item.unidadeMedidaId,
      id: item.precoRegraId,
      prazoCIF: item.prazoPagamentoCIFId,
      prazoFOB: item.prazoPagamentoFOBId,
      createdAt: item.createdAt,
      ativo: true,
      isChecked: false,
      emAprovacao: item.emAprovacao && item?.clienteEmAprovacao?.includes(codigoCliente),
      precosServicos: precosServicos,
      sequencia: item.sequencia,
      color: {
        cif: false,
        fob: false,
      },
    };
  }

  const tabelaPrecoClientesFormatada = useMemo(() => {
    const produtosComPrecoCliente = new Set(
      (tabelaPrecoClientes || [])
        .filter((item) => item.precoClienteId)
        .map((item) => `${item.codigoProduto}-${item.filialLabel}`)
    );

    const faixas = {};
    (tabelaPrecoClientes || [])
      .filter((item) => item.precoClienteId && item.faixa !== undefined)
      .forEach((item) => {
        const chaveUnica = `${item.codigoProduto}-${item.filialId}-${item.microrregiaoId}-${item.clusterId || ""}`;
        faixas[chaveUnica] = item.faixa;
      });

    return [
      {
        outros: [
          {
            checkboxes: false,
            header: {
              title: "Produtos para oferecer",
            },
            produtos: (tabelaPrecoClientes || [])
              .map((item) => {
                const chaveProdutoFilial = `${item.codigoProduto}-${item.filialLabel}`;
                if (item.precoClienteId) return formatPrecoCliente(item);
                if (item.precoRegraId && !produtosComPrecoCliente.has(chaveProdutoFilial)) {
                  const chaveUnica = `${item.codigoProduto}-${item.filialId}-${item.microrregiaoId}-${
                    item.clusterId || ""
                  }`;

                  return formatPrecoRegra(item, faixas, chaveUnica);
                }
              })
              .filter(Boolean),
          },
        ],
      },
    ];
  }, [tabelaPrecoClientes, servicos]);

  const [enabledGetTableaPrecoCliente, setEnabledGetTableaPrecoCliente] = useState(false);
  const tabelaPrecoClienteRequest = useGetTabelaPrecoClienteById(clienteId, enabledGetTableaPrecoCliente);

  async function setTableaPrecoCliente() {
    await (tabelaPrecoClienteRequest?.data || [])?.forEach(async (itens) => {
      await db.tabelaPrecoCliente.bulkPut(itens);
    });

    if (clienteId > 0 && (microrregiao || cluster)) fetchTabelaPrecoClientes();
  }

  async function atualizarPrecosCliente() {
    let response;
    try {
      response = await getPrecoCliente(0, 0, null);
    } catch (apiError) {
      console.error("Erro ao chamar a API de precoCliente:", apiError);
    }
    const dadosValidos = response?.data?.[0];
    if (dadosValidos?.length > 0) {
      try {
        await db.precosCliente.bulkPut(dadosValidos);
      } catch (dbError) {
        console.error("Erro ao inserir dados no IndexedDB:", dbError);
      }
    }
  }

  useEffect(() => {
    if (tabelaPrecoClienteRequest.data && tabelaPrecoClienteRequest.data?.status != 500) {
      (async () => {
        await setTableaPrecoCliente();
        await atualizarPrecosCliente();
      })();
    }
  }, [tabelaPrecoClienteRequest.data]);

  useEffect(() => {
    if (clienteId) {
      setEnabledGetTableaPrecoCliente(true);
    }
  }, [clienteId]);

  return {
    tabelaPrecoClientes,
    tabelaPrecoClientesFormatada,
    total,
    totalRenderizado,
  };
};

export default useTabelaPrecoCliente;
